import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import { Fragment } from 'react'

export default function StateListBox({ onChange, states, value, disabled }) {
    const _onChange = (state) => {
        onChange(state)
    }

    return (
        <div>
            <Listbox disabled={disabled} value={value} onChange={_onChange}>
                <div className="relative mt-1">
                    <Listbox.Button className="mt-1 block w-full min-h-[50px] rounded-md py-3 border border-gray-300 focus:border-yf-green focus:ring-1 focus:ring-yf-green placeholder-gray-400 disabled:bg-gray-300 disabled:opacity-50">
                        <span className="block truncate">
                            {value
                                ? states?.find((item) => item.value === value)?.label
                                : ''}
                        </span>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <SelectorIcon
                                className="w-5 h-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {states.map((state, idx) => (
                                <Listbox.Option
                                    key={idx}
                                    className={({ active }) =>
                                        `${
                                            active
                                                ? 'text-yf-green-600 bg-yf-green-100'
                                                : 'text-gray-900'
                                        }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                                    }
                                    value={state.value}
                                >
                                    {({ selected, active }) => (
                                        <>
                                            <span
                                                className={`${
                                                    selected
                                                        ? 'font-medium text-yf-green'
                                                        : 'font-normal'
                                                } block truncate`}
                                            >
                                                {state.label}
                                            </span>
                                            {selected ? (
                                                <span
                                                    className={`${
                                                        active
                                                            ? 'text-yf-green'
                                                            : 'text-yf-green'
                                                    }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                                                >
                                                    <CheckIcon
                                                        className="w-5 h-5"
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    )
}
